<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>STEP<span>03</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>ショップ情報登録</span></h3>
                <p class="md_annotation"><span>管理画面からショップは無料で複数登録いただけます。</span></p>
            </div>

            <!--item-->
            <div class="item-wrap">

                <!--group-->
                <div class="group">
                    <div class="item form_text">
                        <input type="email" id="shop-name1" placeholder=" " value="">
                        <label for="shop-name1" class="m-label"><span>ショップ名</span></label>
                    </div>
                </div>

                <!--group-->
                <div class="group">
                    <div class="text-wrap">
                        <h4><span>ロゴがある場合は画像をアップロードしてください。</span></h4>
                    </div>
                    <div class="item form_text">
                        Cropper設置予定
                    </div>
                </div>

                <!--group-->
                <div class="group">
                    <div class="text-wrap">
                        <h4><span>ショップ所在地</span></h4>
                    </div>
                    <div class="form_text-wrap">
                        <div class="item form_text">
                            <input type="postal-code" id="shop-postal-code" placeholder=" " value="">
                            <label for="shop-postal-code" class="m-label"><span>郵便番号</span></label>
                        </div>
                    </div>
                    <div class="item form_text">
                        <input type="address-level1" id="shop-address-level1" placeholder=" " value="">
                        <label for="shop-address-level1" class="m-label"><span>都道府県</span></label>
                    </div>
                    <div class="item form_text">
                        <input type="address-level2" id="shop-address-level2" placeholder=" " value="">
                        <label for="shop-address-level2" class="m-label"><span>市区町村</span></label>
                    </div>
                </div>

            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left" disabled><span>Back</span></button>
            <button type="button" class="_right js-swiper-next" v-on:click="scrollTop"><span>Next</span></button>
        </div>

    </div>
</div>
</template>

<script>
    import commonMixins from '@/common/utility.js'
    export default {
        mixins: [commonMixins],
    }
</script>

